var highContrast = false;

console.log("Page type: ");

document.addEventListener('DOMContentLoaded', function() {
    highContrast = localStorage.getItem('highContrast') === 'true';
  const contrastButton = document.getElementById('contrastButton');
    if(highContrast){
      setHighContrastColors();
      contrastButton.innerText = "Standard Theme";
    }
    
    if (contrastButton) {
        contrastButton.addEventListener('click', function() {
            // Toggle highContrast setting
            localStorage.setItem('highContrast', !highContrast);
            highContrast = !highContrast;
            if(highContrast){
              setHighContrastColors();
              contrastButton.innerText = "Standard Theme";
            }
            else{
              location.reload();
            }
        });
    }
});

if(highContrast)
{
  setHighContrastColors;
}
function setHighContrastColors(){
  //HEADER
  document.getElementById("header-wrapper").style.background = "#e3dcd2";
  
  // Select all elements with the class 'cls-1'
  var elements = document.querySelectorAll('.cls-1');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#e3dcd2';
  });

  // Select all elements with the class 'cls-2'
  elements = document.querySelectorAll('.cls-2');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      console.log("in here");
      element.style.fill = '#f2400b';
  });

  // Select all elements with the class 'cls-3'
  elements = document.querySelectorAll('.cls-3');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });

  elements = document.querySelectorAll('.icon-cart-color');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });

  elements = document.querySelectorAll('.account-icon-color');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });
  document.getElementById("header-divider").style.backgroundColor = "#000000";

  //MAIN ITEMS
  document.body.style.background = "#e3dcd2";

  elements = document.querySelectorAll('.history-card');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.background = '#e3dcd2';
  });

  elements = document.querySelectorAll('.history-badge');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.background = '#f2400b';
      element.style.borderColor = '#f2400b';
      element.style.color = '#000000';
  });

  elements = document.querySelectorAll('.active-release');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });

  elements = document.querySelectorAll('.product-form__submit');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.background = '#000000';
      element.style.color = '#e3dcd2';
  });

  elements = document.querySelectorAll('hr');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.background = '#000000';
  });

  elements = document.querySelectorAll('.two-column-grid');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.background = '#000000';
  });

  elements = document.querySelectorAll('.h1');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#e3dcd2';
  });
  elements = document.querySelectorAll('span');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });

  elements = document.querySelectorAll('.icon-forward-color');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });
}


